import { useEffect, useState } from 'react';

export default function useMedia(queries, values, defaultValue) {
    // Array containing a media query list for each query
    const mediaQueryLists = queries.map(q => window.matchMedia(q));
    const [value, setValue] = useState(getValue);

    function getValue() {
        // Get index of first media query that matches
        const index = mediaQueryLists.findIndex(mql => mql.matches);
        return typeof values[index] !== 'undefined' ? values[index] : defaultValue;
    };

    useEffect(() => {
        // Note: By defining getValue outside of useEffect we ensure that it has ...
        // ... current values of hook args (as this hook only runs on mount/dismount).
        const handler = () => setValue(getValue);
        // Set a listener for each media query with above handler as callback.
        mediaQueryLists.forEach(mql => mql.addListener(handler));
        // Remove listeners on cleanup
        return () => mediaQueryLists.forEach(mql => mql.removeListener(handler));
        //eslint-disable-next-line
    }, []);

    return value;
}

export function useScreenSize() {
    return useMedia(
        // Media queries
        ['(min-width: 1024px)', '(min-width: 768px)', '(min-width: 640px)', '(min-width: 360px)'],
        // Supported screen sizes (relates to above media queries by array index)
        ["lg", "md", "sm", "xs"],
        // Default screen size
        "xs"
    )
}